import { operationMessage, type NoteOperation } from '../domain/noteOperations'

export function ActionsLog({ operations, busy, onUndo }: {
  operations: readonly NoteOperation[]
  busy: boolean
  onUndo: (operation: NoteOperation) => void
}) {
  if (!operations.length) return <p className="actions-log__status" role="status">No actions yet. Merges and tag changes will appear here.</p>
  return <ul className="actions-log" aria-label="Note actions">
    {operations.map(operation => <li key={operation.id}>
      <div className="actions-log__detail">
        <span>{operation.kind === 'merge' ? `Merged ${operation.count} notes` : operationMessage(operation)}</span>
        <time dateTime={new Date(operation.createdAt).toISOString()}>{new Date(operation.createdAt).toLocaleString()}</time>
      </div>
      {operation.undone
        ? <span className="actions-log__status">Undone</span>
        : <button type="button" className="btn btn-ghost" disabled={busy} onClick={() => onUndo(operation)}>Undo</button>}
    </li>)}
  </ul>
}
